import { Button, Callout } from '@treams/treams-ui';
import useDetectPrint from 'conversations/evaluation-submission/hooks/useDetectPrint';
import * as graphql from 'generated/graphql';
import { useTranslation } from 'react-i18next';
import SignModal from './modals/SignModal';
import { useState } from 'react';

import styled from 'styled-components';

import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';

const ConversationArchivedCallout = styled.div`
	margin-bottom: 10px;
	padding: 10px;
	background: rgba(${(props) => toRgbString(props.theme.colors.yellow)}, 0.25);
	color: ${(props) => props.theme.colors.yellow};
	border-radius: 5px;
`;

export default function ConversationCallout({
	conversation,
}: {
	conversation: graphql.Conversation;
}) {
	const { t } = useTranslation();
	const isPrinting = useDetectPrint();

	const hasSigned = conversation.submissions.find(
		(submission) =>
			submission.participant.user.id === conversation.viewer.user.id && submission.hasSigned,
	);

	const [showSignModal, setSignModal] = useState(false);

	return (
		<>
			<SignModal
				conversationID={conversation.id}
				onDismiss={() => setSignModal(false)}
				opened={showSignModal}
			/>
			{conversation.viewerCanShare && (
				<Callout
					mb={3}
					title={t('conversation.process.callout.share.title')}
					description={t('conversation.process.callout.share.description')}
					color={'blue'}
				/>
			)}

			{conversation.viewerRequiresInput &&
				!conversation.viewerCanShare &&
				!conversation.viewerCanSign && (
					<Callout
						mb={3}
						title={t('conversation.process.callout.nosignature.title')}
						description={t('conversation.process.callout.nosignature.description')}
						color={'blue'}
					/>
				)}

			{!conversation.viewerRequiresInput && !conversation.viewerCanSign && (
				<Callout
					mb={3}
					title={t('conversation.process.callout.noinput.title')}
					description={t('conversation.process.callout.noinput.description')}
					color={'blue'}
				/>
			)}

			{hasSigned && (
				<Callout
					mb={3}
					title={t('conversation.process.callout.aftersigning.title')}
					description={t('conversation.process.callout.aftersigning.description')}
					color={'blue'}
				/>
			)}

			{conversation.viewerCanSign && (
				<Callout
					title={t('conversations.confirm.reminder.title')}
					description={t('conversations.confirm.reminder.description')}
					color="blue"
					mb={3}
				>
					<Button
						type="card"
						title={t('conversations.confirm.reminder.button')}
						small
						mr={2}
						onClick={() => setSignModal(true)}
					/>
				</Callout>
			)}

			{!isPrinting && conversation.isArchived && (
				<ConversationArchivedCallout>
					{t('evaluations.submission.archivedByEitherParty')}
				</ConversationArchivedCallout>
			)}
		</>
	);
}
